// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const filterImages = (sentMessages) => {
    // Only one message can include images, so we keep only the latest.
    const lastMessageWithImage = (() => {
        for (let i = sentMessages.length - 1; i >= 0; i--) {
            if (sentMessages[i].content.some((item) => item.type === "image_url")) {
                return i;
            }
        }
        return -1;
    })();
    return sentMessages.map((message, index) => {
        const hasImageUrl = message.content.some((c) => c.type === "image_url");
        if (!hasImageUrl) {
            return message;
        }
        const isLatestWithImageUrl = index === lastMessageWithImage;
        return Object.assign(Object.assign({}, message), { content: message.content.filter((item) => item.type !== "image_url" || isLatestWithImageUrl) });
    });
};
export function loadImage(selectedFile) {
    return new Promise((resolve, reject) => {
        // reader.readAsText(fileContent);
        const reader = new FileReader();
        reader.readAsDataURL(selectedFile); // This reads the file as a data URL (base64 encoded)
        reader.onload = () => __awaiter(this, void 0, void 0, function* () {
            const base64Image = reader.result; // e.g., "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQ..."
            resolve(base64Image); // Resolve with the base64 image data
        });
        reader.onerror = (error) => {
            console.error("Error reading file:", error);
        };
    });
}
